/**
 * Cross-browser audio recorder helper.
 * iOS Safari does NOT support `audio/webm` — only `audio/mp4`. Chrome/Firefox prefer webm.
 * We probe supported mime types and pick the first available.
 */

const CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4;codecs=mp4a.40.2',
  'audio/mp4',
  'audio/ogg;codecs=opus',
  'audio/wav',
];

export function pickAudioMimeType() {
  if (typeof MediaRecorder === 'undefined') return { type: '', ext: 'webm' };
  for (const t of CANDIDATES) {
    if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(t)) {
      const base = t.split(';')[0]; // strip codec
      let ext = 'webm';
      if (base.includes('mp4')) ext = 'm4a';
      else if (base.includes('ogg')) ext = 'ogg';
      else if (base.includes('wav')) ext = 'wav';
      else if (base.includes('webm')) ext = 'webm';
      return { type: t, ext };
    }
  }
  // Fallback: let the browser choose
  return { type: '', ext: 'webm' };
}

/**
 * Create a MediaRecorder using the best-supported mime type for the current browser.
 * Returns { recorder, mimeInfo }.
 */
export function createRecorder(stream) {
  const mimeInfo = pickAudioMimeType();
  try {
    const recorder = mimeInfo.type
      ? new MediaRecorder(stream, { mimeType: mimeInfo.type })
      : new MediaRecorder(stream); // let browser pick
    return { recorder, mimeInfo };
  } catch (err) {
    // Last-resort: no options
    const recorder = new MediaRecorder(stream);
    return { recorder, mimeInfo };
  }
}
